import { Button } from "@mui/material";
import { useRouter } from "next/router";
import { FC, useState, useEffect } from "react";
import {
  useCheckoutFromPaymentFailedOrderMutation,
  useCODFromPaymentFailedOrderMutation,
} from "../../../../store";
import { TransformedOrderDetailsEntity } from "../../../../types/order_types";
import { PaymentDialog } from "../../../organisms/PaymentDialog";

export const CompletePaymentButtons: FC<{
  order: TransformedOrderDetailsEntity;
}> = ({ order }) => {
  const router = useRouter();
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [
    checkoutFromPaymentFailedOrder,
    { isSuccess: checkoutFromPaymentFailedOrderSuccess },
  ] = useCheckoutFromPaymentFailedOrderMutation();
  const [
    CODFromPaymentFailedOrder,
    { isSuccess: CODFromPaymentFailedOrderSuccess, data },
  ] = useCODFromPaymentFailedOrderMutation();

  useEffect(() => {
    if (checkoutFromPaymentFailedOrderSuccess) {
      CODFromPaymentFailedOrder({ checkoutToken: order.checkoutToken });
    }
  }, [checkoutFromPaymentFailedOrderSuccess]);
  useEffect(() => {
    if (CODFromPaymentFailedOrderSuccess) {
      router.push("/checkout/thankyou?id=" + data.result.orderId);
    }
  }, [CODFromPaymentFailedOrderSuccess]);

  const convertToCOD = async () => {
    await checkoutFromPaymentFailedOrder({
      checkoutToken: order!.checkoutToken,
      paymentMethodId: 1,
    });
  };
  return (
    <>
      <div className="flex gap-4 items-center">
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={convertToCOD}>
          Convert to COD
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => setShowPaymentDialog(true)}>
          Complete Payment Now
        </Button>
      </div>
      <PaymentDialog
        open={showPaymentDialog}
        onClose={() => setShowPaymentDialog(false)}
        paymentURL={order?.payment?.paymentLink}
      />
    </>
  );
};
